import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgJob = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M17.25 13.2404V15.65C17.25 16.2101 17.25 16.4901 17.141 16.704C17.0451 16.8922 16.8922 17.0451 16.704 17.141C16.4901 17.25 16.2101 17.25 15.65 17.25H4.35C3.78995 17.25 3.50992 17.25 3.29601 17.141C3.10785 17.0451 2.95487 16.8922 2.85899 16.704C2.75 16.4901 2.75 16.2101 2.75 15.65V13.2404M13.25 5.75V4.35C13.25 3.78995 13.25 3.50992 13.141 3.29601C13.0451 3.10785 12.8922 2.95487 12.704 2.85899C12.4901 2.75 12.2101 2.75 11.65 2.75H8.35C7.78995 2.75 7.50992 2.75 7.29601 2.85899C7.10785 2.95487 6.95487 3.10785 6.85899 3.29601C6.75 3.50992 6.75 3.78995 6.75 4.35V5.75M12.25 11.75V14.25M7.75 11.75V14.25M3.35 13.25H16.65C17.2101 13.25 17.4901 13.25 17.704 13.141C17.8922 13.0451 18.0451 12.8922 18.141 12.704C18.25 12.4901 18.25 12.2101 18.25 11.65V7.35C18.25 6.78995 18.25 6.50992 18.141 6.29601C18.0451 6.10785 17.8922 5.95487 17.704 5.85899C17.4901 5.75 17.2101 5.75 16.65 5.75H3.35C2.78995 5.75 2.50992 5.75 2.29601 5.85899C2.10785 5.95487 1.95487 6.10785 1.85899 6.29601C1.75 6.50992 1.75 6.78995 1.75 7.35V11.65C1.75 12.2101 1.75 12.4901 1.85899 12.704C1.95487 12.8922 2.10785 13.0451 2.29601 13.141C2.50992 13.25 2.78995 13.25 3.35 13.25Z",
		stroke: "currentColor",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
const ForwardRef = forwardRef(SvgJob);
export { ForwardRef as ReactComponent };
